<div class="card infosection" *ngIf="merchant">
  <a href="{{merchant.logoTarget}}" (click)="track(merchant.logoEvent)"><img class="header-img" src="{{merchant.logo}}" /></a>
  <div class="header-text">{{merchant.description}}</div>
  <div class="container">
    <div class="info step" *ngFor="let step of merchant.steps">
      <span class="step-count">{{step.step}}</span>
      <img src="{{step.image}}">
      <div class="text">{{step.text}}</div>
    </div>
    <a class="btn btn-block waves-effect zest-btn" href="{{merchant.ctaTarget}}" (click)="track(merchant.ctaEvent)"> {{merchant.ctaText}} </a>
  </div>
</div>